import { ExperimentsQuery, ExperimentsQueryVariables } from './__generated__/ExperimentsQuery';
import { useLazyQuery } from '@apollo/react-hooks';
import { kmsClient } from 'api';
import { EXPERIMENTS_QUERY } from './experiments.query';

export const useExperimentsQuery = (variables: ExperimentsQueryVariables) => {
  return useLazyQuery<ExperimentsQuery>(EXPERIMENTS_QUERY, {
    variables,
    client: kmsClient,
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'network-only'
  });
};
